class Deferred<T> {
  public promise: Promise<T>;
  public resolve: (value?: T | PromiseLike<T> | undefined) => void;
  public reject: (reason?: any) => void;

  constructor() {
    this.resolve = Promise.resolve;
    this.reject = Promise.reject;

    this.promise = new Promise<T>((resolve, reject) => {
      this.resolve = resolve;
      this.reject = reject;
    });
  }
}

export default Deferred;
